import React from "react";
import { createPortal } from "react-dom";
import { ExternalLink, X } from "lucide-react";

export default function MediaViewer({ open, src, alt, onClose }) {
  if (!open || !src) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/85 px-4 py-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-4 top-4 rounded-full bg-slate-900/80 p-2 text-slate-100 hover:bg-slate-800"
        aria-label="Fechar imagem"
      >
        <X className="h-5 w-5" />
      </button>
      <a
        href={src}
        target="_blank"
        rel="noreferrer"
        onClick={(event) => event.stopPropagation()}
        className="absolute right-16 top-4 rounded-full bg-slate-900/80 p-2 text-slate-100 hover:bg-slate-800"
        aria-label="Abrir imagem em nova aba"
      >
        <ExternalLink className="h-5 w-5" />
      </a>
      <img
        src={src}
        alt={alt || "Imagem"}
        className="max-h-[86vh] max-w-[92vw] rounded-lg object-contain shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      />
    </div>,
    document.body
  );
}
